import clone from '@fno/lib/clone.js'

// When you reset a form, it clones off the original context form object
// and fully overwrites it.
export default ({ component }) => ({ detail: { context } }) => {
    context.form = clone(context.original)
    component.$set({ context })
}
